import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { IExamQuestionAdminMetaVm } from '../models/exam-question-admin-meta-vm';

@Injectable({
  providedIn: 'root',
})
export class GetQestionsBaseService {
  private http = inject(HttpClient);

  public getQuestionsBase$(
    take: number,
    skip: number,
    search: string
  ): Observable<IExamQuestionAdminMetaVm> {
    return this.http.get<IExamQuestionAdminMetaVm>(
      environment.webApiUrl +
        '/QuestionsBase?take=' +
        take +
        '&skip=' +
        skip +
        '&search=' +
        search
    );
  }
}
